import { useCallback, useMemo } from 'react';
import { move, path } from 'ramda';
const onlyIgnoredInSettings = (column) => column.ignoreInSettings;
const filterIgnoreSet = (ignoredColumnIds) => (id) => !ignoredColumnIds.has(id);
export const useColumnsList = (columns, columnOrder) => {
    const orderedColumnIds = useMemo(() => (columnOrder.length ? [...columnOrder] : columns.map(path(['id']))), [columnOrder, columns]);
    const ignoredColumnIds = useMemo(() => new Set(columns.filter(onlyIgnoredInSettings).map(path(['id']))), [columns]);
    const filteredColumnIds = useMemo(() => orderedColumnIds.filter(filterIgnoreSet(ignoredColumnIds)), [orderedColumnIds, ignoredColumnIds]);
    return { orderedColumnIds, filteredColumnIds };
};
export const useChangeColumnOrder = (orderedColumnIds, filteredColumnIds, setColumnOrder) => useCallback((dragIndex, hoverIndex) => {
    const draggedId = filteredColumnIds[dragIndex];
    const hoveredId = filteredColumnIds[hoverIndex];
    dragIndex = orderedColumnIds.indexOf(draggedId);
    hoverIndex = orderedColumnIds.indexOf(hoveredId);
    const result = move(dragIndex, hoverIndex, orderedColumnIds);
    setColumnOrder(result);
}, [orderedColumnIds, filteredColumnIds, setColumnOrder]);
